import axios from 'axios';
// config
import { HOST_API } from '../config';

// interface Props {
//   XAuthoken: string;
// }
// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
  timeout: 30000, // 30 second timeout
});

// Request interceptor to add auth token to all requests
axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('accessToken');
    
    // Don't add auth token to login/register endpoints
    const isAuthEndpoint = config.url?.includes('/login') || 
                          config.url?.includes('/register') ||
                          config.url?.includes('/signup');
    
    if (accessToken && config.headers && !isAuthEndpoint) {
      // Use afrofitapp as the auth header key
      config.headers['afrofitapp'] = accessToken;
    }
    
    // Log requests in development
    // @ts-ignore - process.env is replaced at build time
    if (process.env.NODE_ENV === 'development') {
      console.log('📤 API Request:', {
        method: config.method?.toUpperCase(),
        url: config.url,
        baseURL: config.baseURL,
        hasAuthToken: !!config.headers?.['afrofitapp']
      });
    }
    
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for better error handling
axiosInstance.interceptors.response.use(
  (response) => {
    // Log responses in development
    // @ts-ignore - process.env is replaced at build time
    if (process.env.NODE_ENV === 'development') {
      console.log('📥 API Response:', {
        status: response.status,
        url: response.config.url,
      });
    }
    return response;
  },
  (error) => {
    // Extract error message
    const message = error.response?.data?.message || 
                   error.response?.data?.error ||
                   error.message || 
                   'Something went wrong';
    
    // Handle specific error codes
    if (error.response) {
      const { status } = error.response;
      
      switch (status) {
        case 401:
          // Unauthorized - clear session and redirect to login (but not if already on login page)
          console.error('Unauthorized:', message);
          if (!window.location.pathname.includes('/auth/login')) {
            localStorage.clear();
            window.location.href = '/auth/login';
          }
          break;
        
        case 403:
          // Forbidden - user doesn't have permission
          console.error('Forbidden - insufficient permissions');
          break;
        
        case 404:
          // Not found
          console.error('Resource not found');
          break;
        
        case 500:
          // Server error
          console.error('Server error:', message);
          break;
        
        default:
          console.error(`Error ${status}:`, message);
      }
    } else if (error.request) {
      // Request was made but no response received
      console.error('No response from server - check network connection');
    } else {
      // Error setting up the request
      console.error('Request setup error:', error.message);
    }
    
    // Return a properly formatted error with message property
    const enhancedError: any = new Error(message);
    enhancedError.status = error.response?.status;
    enhancedError.data = error.response?.data;
    return Promise.reject(enhancedError);
  }
);

export default axiosInstance;
